import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { ReporteService } from 'src/app/services/reporte.service';

@Component({
  selector: 'app-deportistas-por-expirar',
  templateUrl: './deportistas-por-expirar.component.html',
  styleUrls: ['./deportistas-por-expirar.component.scss']
})
export class DeportistasPorExpirarComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public reporteSvc: ReporteService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'contacto',
      'fecha',
      'dias',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getDeportistasPorExpirar(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDeportistasPorExpirar(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.reporteSvc
      .getDeportistasPorExpirar(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
      });

  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getDeportistasPorExpirar(event.pageIndex, event.pageSize);
  }

}
